/**
 * Created by olga on 21.05.2024
 */

const PuzzleStickerView = cc.Node.extend({
    ctor: function (sticker, options) {
        options = options || {};
        this._super();

        this.sticker = sticker;
        this.placeholder = options.placeholder;

        this.image = new cc.Sprite(sticker.image);
        this.addChild(this.image);

        this.setAnchorPoint(0.5, 0);

        this.setContentSize2(cleverapps.styles.PuzzlesComponent.placeholder);

        this.createStars();

        this.image.setAlignment(cleverapps.styles.PuzzleStickerView.position);

        this.setCascadeOpacityEnabledRecursively(true);

        if (this.placeholder) {
            this.addShadow();
        }

        this.update();

        if (options.withUpdate) {
            sticker.on("update", this.createListener(this.update.bind(this)));
        }
    },

    update: function () {
        this.image.setVisible(this.sticker.isOpen());
        this.shadow && this.shadow.setVisible(this.sticker.isOpen());
    },

    highlight: function () {},

    addShadow: function () {
        const shadow = this.shadow = new cleverapps.Spine(bundles.sticker.jsons.puzzle_shadow_json);

        this.addChild(shadow);
        shadow.setSkin(this.sticker.getIndex());
        shadow.setAlignment(cleverapps.styles.PuzzleStickerView.shadow);
        shadow.setLocalZOrder(-1);

        shadow.setAnimation(0, "idle_close", true);
    },

    calculateViewPosition: function () {
        return this.convertToWorldSpace(this.image.getPosition());
    },

    animateDragStart: function () {
        cleverapps.effects.fire("stickers.puzzle.hand");

        const dragOffset = cleverapps.styles.PuzzleStickerView.dragOffset;
        this.image.runAction(new cc.MoveBy(0.1, dragOffset.x, dragOffset.y).easing(cc.easeExponentialOut(2)));
        this.runAction(new cc.ScaleTo(0.1, 1 / this.slot.scale).easing(cc.easeIn(2)));

        this.shadow.setAnimationAndIdleAfter("open", "idle_open");
    },

    createStars: function () {
        const styles = cleverapps.styles.PuzzleStickerView;

        if (styles.stars && this.sticker.hasAttention()) {
            const stars = this.stars = new cc.Sprite(bundles.sticker.frames[`back_icon_${this.sticker.rarity}_png`]);
            this.addChild(stars);
            stars.setAlignment(styles.stars);
            stars.setLocalZOrder(2);
        }

        if (styles.rarityIndicator && this.placeholder) {
            const indicator = this.rarityIndicator = new cc.Sprite(bundles.sticker.frames[`back_icon_${this.sticker.rarity}_inactive_png`]);
            this.placeholder.addChild(indicator);
            indicator.setAlignment(styles.rarityIndicator);
        }
    },

    animateEndDrag: function (options) {
        let actions = [];
        this.stopAllActions();

        const slotScale = this.slot.getScale();

        const scale = this.scale;
        this.scale = 1;
        let targetPosition = this.parent.convertToWorldSpace(this.positionFromAlignment(cleverapps.styles.PuzzleStickerView.position));
        this.scale = scale;

        const parent = this.parent;

        this.replaceParentSamePlace(cleverapps.Scenes.GetMovingNode(), {
            keepScale: true
        });

        targetPosition = cleverapps.Scenes.GetMovingNode().convertToNodeSpace(targetPosition);

        if (options.animateWrong) {
            actions = actions.concat([
                new cc.CallFunc(() => {
                    this.animatePuzzle(false);
                    cleverapps.effects.fire("stickers.puzzle.wrong");
                }),
                new cc.RotateBy(0.1, 10),
                new cc.RotateBy(0.2, -20),
                new cc.RotateBy(0.1, 10)
            ]);
        }

        this.shadow.setAnimationAndIdleAfter("close", "idle_close");

        const dragOffset = cleverapps.styles.PuzzleStickerView.dragOffset;
        actions = actions.concat([
            new cc.Spawn(
                new cc.ScaleTo(0.1, slotScale),
                new cc.MoveTo(
                    0.1, 
                    targetPosition
                ).easing(cc.easeOut(1)),
                new cc.CallFunc(() => {
                    this.image.runAction(new cc.MoveBy(0.1, dragOffset.x, -dragOffset.y));
                })
            ),
            new cc.ScaleTo(0.1, slotScale - 0.1).easing(cc.easeOut(1)),
            new cc.ScaleTo(0.1, slotScale).easing(cc.easeIn(1)),

            new cc.CallFunc(() => {
                cleverapps.effects.fire("stickers.puzzle.sleeve");
                options.callback();
            })
        ]);

        this.runAction(new cc.Sequence(actions).setFinalize(() => {
            this.replaceParentSamePlace(parent, {
                keepScale: true
            });
        }));
    },

    animatePutUp: function () {
        this.stopAllActions();
        this.image.stopAllActions();

        this.image.setAlignment(cleverapps.styles.PuzzleStickerView.position);

        this.animatePuzzle(true);
        cleverapps.effects.fire("stickers.puzzle.put");

        this.shadow.setAnimationAndIdleAfter("close", "idle_close");

        if (this.stars) {
            this.stars.removeFromParent();
        }
        this.removeRarityIndicator();
    },

    removeRarityIndicator: function () {
        if (this.rarityIndicator) {
            this.rarityIndicator.removeFromParent();
        }
    },

    animatePuzzle: function (isCorrect) {
        const spineName = isCorrect ? "correct_puzzle_json" : "wrong_puzzle_json";
        const animation = new cleverapps.Spine(bundles.sticker.jsons[spineName]);
        this.addChild(animation);
        animation.setLocalZOrder(isCorrect ? -1 : 10);
        animation.setAlignment(this.width / 2, this.height / 2);

        animation.setAnimation(0, "animation", false);
        animation.setCompleteListenerRemove();
    },

    createBadge: function () {
        const styles = cleverapps.styles.StickerView.badge;

        const badge = this.badge = new cc.Sprite(bundles.sticker.frames.sticker_badge_png);
        badge.setLocalZOrder(10);

        const text = cleverapps.UI.generateOnlyText(Messages.get("Attention.Text"), cleverapps.styles.FONTS.COLLECTION_BADGE_TEXT);
        badge.addChild(text);
        text.setAlignment(styles.text);
        text.fitTo(styles.text.maxWidth);
        text.setRotation(styles.text.rotation);

        this.addChild(badge);
        badge.setAlignment(styles);
    }
    
});

cleverapps.styles.PuzzleStickerView = {
    shadow: {
        x: { align: "center", dx: 3 },
        y: { align: "center", dy: -11 }
    },
    dragOffset: {
        x: 0,
        y: 60
    },
    position: {
        x: { align: "center" },
        y: { align: "center" }
    },
    stars: undefined
};
